<template>
    <div class="tab-content-container">
        <div class="tab-header-container">
            <h2 class="form-label">Образование</h2>
            <LiteButton @click.native="editButtonClicked"
                        class="edit-button"
                        v-show="!shouldEdit"
                        :hoverColor="'blue'"
                        :icon="'far fa-edit'">
            </LiteButton>
            <LiteButton @click.native="editButtonClicked"
                        style="font-size: 27px;"
                        class="edit-button"
                        v-show="shouldEdit"
                        :hoverColor="'red'"
                        :icon="'far fa-window-close'">
            </LiteButton>
        </div>

        <hr class="form-line">

        <div class="item-container very-light-shadow"
             v-for="education in workerEducationsCache" :key="education.id">

            <p class="item-label" v-text="education.description"></p>

            <LiteButton @click.native="removeEducation(education)"
                        class="edit-button delete-icon"
                        v-show="shouldEdit"
                        :hoverColor="'red'"
                        :icon="'far fa-trash-alt'">
            </LiteButton>

            <div class="last-modified-container">
                <p class="last-modified-date" v-text="getWorkerEducationsLastModifiedDate(education)"></p>
                <p class="last-modified-name" v-text="getWorkerEducationsLastModifiedBy(education)"></p>
            </div>
        </div>

        <div class="add-item-container" v-if="shouldEdit">
            <InputText class="item-input"
                       :id="'education'"
                       :name="'education-description'"
                       @value-change="currentDescriptionChange"
                       :label="'Добавяне на образование'"
                       :newValue="currentDescription"
                       :placeholder="'Опишете образованието'">
            </InputText>
            <LiteButton @click.native="addEducation"
                        class="add-item-icon"
                        :hoverColor="'green'"
                        :icon="'far fa-plus-square'">
            </LiteButton>
        </div>

        <Button class="save-button"
                v-if="shouldEdit"
                @click.native="saveEducations"
                :color="'green'"
                :text="'Запази'"
                :icon="'fa fa-save'"></Button>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import InputText from "@/shared/components/form/InputText";
    import Button from "@/shared/components/button/Button";
    import LiteButton from "@/shared/components/button/LiteButton";
    import workerService from "@/services/worker.service";
    import mapperService from "@/services/mapper.service";
    import {cloneDeep} from 'lodash';

    export default {
        name: "workerEducationsForm",
        components: {LiteButton, InputText, Button},
        created() {
            this.workerEducationsCache = cloneDeep(this.workerEducations);
        },
        data() {
            return {
                workerId: this.$route.params.id,
                shouldEdit: false,
                workerEducationsCache: cloneDeep(this.workerEducations),
                currentDescription: ''
            }
        },
        methods: {
            currentDescriptionChange(value) {
                this.currentDescription = value.currentValue;
            },
            editButtonClicked() {
                this.shouldEdit = !this.shouldEdit;
                this.workerEducationsCache = cloneDeep(this.workerEducations);
            },
            addEducation() {
                if (this.currentDescription) {
                    this.workerEducationsCache.push({
                        workerId: this.workerId,
                        description: this.currentDescription
                    });
                    this.currentDescription = '';
                }
            },
            saveEducations() {
                workerService.updateEducations(this.workerId, this.workerEducationsCache)
                    .then(({data}) => {
                        this.$store.commit('setWorkerEducations', data);
                        this.shouldEdit = false;
                    })
                    .catch(() => alert("Грешка, моля опитайте отново!"));
            },
            getWorkerEducationsLastModifiedBy(education) {
                return mapperService.getLastModifiedBy(education);
            },
            getWorkerEducationsLastModifiedDate(education) {
                return mapperService.getLastModifiedDate(education);
            },
            removeEducation(education) {
                this.workerEducationsCache = this.workerEducationsCache.filter((temp) => {
                    if (education.id) {
                        return temp.id !== education.id
                    }
                    return temp.description !== education.description;
                });
            }
        },
        computed: {
            ...mapGetters(['workerEducations'])
        },
        watch: {
            workerEducations: {
                handler(newVal) {
                    if (newVal) {
                        this.workerEducationsCache = cloneDeep(newVal);
                    }
                },
                deep: true
            }
        }
    }
</script>

<style scoped>
    .add-item-container {
        margin-top: 50px;
        width: 100%;
        display: inline-block;
    }

    .item-input {
        width: 400px;
        height: 95px;
        float: left;
    }

    .add-item-icon {
        font-size: 40px;
        float: left;
        width: fit-content;
        height: 100%;
        margin: 36px;
        color: var(--slight-light-green);
    }

</style>